const source = 'podsDataTable'

function prospettoConsumi() {

  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-prospetto-consumi',
      title: 'Prospetto Consumi',
      data: ids,
      maximize: false,

    })
  } 
}

export default {
  'bindTo': 'this',
  'method': prospettoConsumi,
}
